import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { getNavItems } from "../NavBar/helper";
import Item from "./components/Item";
import styles from "./styles.module.css";

const Sidebar = ({ toggle }) => {
  const { t, i18n } = useTranslation();
  const [items, setItems] = useState([]);
  const [expandItem, setExpandItem] = useState(null);

  const goToLink = (item) => {
    window.open(`${item[`link_${i18n.language}`]}`, "_blank");
  };

  useEffect(() => {
    setItems([...getNavItems(t)]);
  }, [i18n.language]);

  const renderItem = (item) => (
    <Item
      key={item.title}
      data={item}
      goToLink={goToLink}
      expandItem={expandItem}
      setExpandItem={setExpandItem}
    />
  );

  return (
    <div onClick={toggle} className={styles.filter}>
      <div onClick={(e) => e.stopPropagation()} className={`${styles.sidebar}`}>
        {items.map(renderItem)}
      </div>
    </div>
  );
};

export default Sidebar;
